import {
  payloadComputedProperty,
  SB,
  searchableComputedProperty,
  teaHash,
} from '@play-co/replicant';
import { Admin } from './admin';
import { State } from './State';
import { encodePacket } from './utils/encoder';
import { Social } from './social';
import { Pet } from './buruburu/pet';
import { visitProperties } from './visit/visit.properties';
import { Profile } from './profile';

export default {
  // Admin computed properties
  ...Admin.properties,
  ...Social.properties,
  ...Pet.properties,
  ...visitProperties,
  ...Profile.properties,

  /** IDs of playing friends. */
  friendIds: searchableComputedProperty(SB.array(SB.string()), (state: State) =>
    Object.keys(state.friends).sort(),
  ),

  updatedAt: searchableComputedProperty(SB.int(), (state: State) => {
    // Round down to latest passed hour to prevent updating index on each replication, and
    // offset with hashed user ID to prevent hourly indexing spikes:
    const offset = Math.floor(teaHash(state.id) * 1000 * 60 * 60);

    return new Date(state.updatedAt - offset).setMinutes(0, 0, 0);
  }),

  maskedUID: searchableComputedProperty(SB.string(), (state: State) =>
    encodePacket(state.id),
  ),
};
